import React, { useState, useEffect } from "react";
import FormInput from "../../../props/propertyFormProp";
import { patchDataForm } from "../../../fetchRoutes/patchDataForm";

export default function UpdatePropertyForm({myProperty, onClose}) {

    const updateProperty = process.env.REACT_APP_PROPERTY;
  
    const updateURL = `${updateProperty}/${myProperty._id}/update`;

    
    const [property, setProperty] = useState({
        title: '',
        description: '',
        price: '',
        address: '',
        rooms: '',
        bathrooms: '',
        receptions: '',
        legalTerms: '',
        disclaimer: '',
        termsForSale: ''

    });

    const [formStep, setFormStep] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errors, setErrors] = useState({});
    const [isValid, setIsValid] = useState(false);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setProperty({ ...property, [name]: value });

        // Clear the error when the user starts typing
        setErrors((prev) => ({ ...prev, [name]: "" }));
        validateFields(name, value);
    };


    const nextStep = () => {
        setFormStep(2);
    };

    const prevStep = () => {
        setFormStep(1);
    };


    const validateFields = (name, value) => {
        let message = "";
    
        // Skip validation for empty fields
        if (!value) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: "", // Clear any existing error for this field
            }));
            return;
        }
    
        // Validation rules
        switch (name) {
            case "title":
                message = value.length < 3 ? "Must be at least 3 characters long" : "";
                break;
            case "description":
                message = value.length < 100 ? "Must be at least 100 characters long" : "";
                break;
            case "price":
                message = isNaN(value) || value <= 100 ? "Must be a number over 100" : "";
                break;
            case "address":
                message = value.length <= 2 ? "Valid address is required" : "";
                break;
            case "rooms":
            case "bathrooms":
            case "receptions":
                message = isNaN(value) || value < 0 ? "Must be >=0" : "";
                break;
            case "legalTerms":
                message =value.length < 100 ? "Must be at least 100 characters long" : "";
                break;
            case "disclaimer":
                message =value.length < 100 ? "Must be at least 100 characters long" : "";
                break;
            case "termsForSale":
                message = value.length < 100 ? "Must be at least 100 characters long" : "";
                break;
            default:
                message = "";
        }
    
        // Update errors state
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: message,
        }));
    };
    


    useEffect(() => {
        const validateForm = () => {
            const newErrors = {};
    
            // Validate only fields with non-empty values
            Object.keys(property).forEach((key) => {
                if (property[key]) {
                    validateFields(key, property[key]);
                    if (errors[key]) {
                        newErrors[key] = errors[key];
                    }
                }
            });
    
            // Check if there are NO errors
            const hasNoErrors = Object.keys(newErrors).length === 0;
            setIsValid(hasNoErrors);
        };
    
        validateForm();
        // eslint-disable-next-line
    }, [property]); 
    

    // Add property
    const handleFormSubmit = async (event) => {
        event.preventDefault();
    
        setIsLoading(true);
        setSuccessMessage("");
        setErrorMessage("");
    
        try {
            const formData = new FormData();
    
            // Add only the fields that have values (ignore empty fields)
            Object.keys(property).forEach((key) => {
                if (property[key]?.trim()) {
                    formData.append(key, property[key]);
                }
            });
    
            // Ensure at least one field is being updated
            if (!formData.has("title") && !formData.has("description") && !formData.has("price") &&
                !formData.has("address") && !formData.has("rooms") && !formData.has("bathrooms") &&
                !formData.has("receptions") && !formData.has("legalTerms") && !formData.has("disclaimer") &&
                !formData.has("termsForSale")) {
                setErrorMessage("Please update at least one field.");
                setTimeout(() => setErrorMessage(""), 3000);
                setIsLoading(false);
                return;
            }
            
            // Make the API request
            const response = await patchDataForm(updateURL, formData);
    
            if (response.status === "Success") {

                onClose();
                setSuccessMessage("Property updated successfully!");
                setTimeout(() => setSuccessMessage(""), 3000);
                
                //Reset form fields
                setProperty({
                    title: '',
                    description: '',
                    price: '',
                    address: '',
                    rooms: '',
                    bathrooms: '',
                    receptions: '',
                    legalTerms: '',
                    disclaimer: '',
                    termsForSale: ''
                });

            } else {
                setErrorMessage(response.message);
                setTimeout(() => setErrorMessage(""), 3000);
            }
        } catch (error) {
            console.error("Error updating property:", error);
            setErrorMessage("Failed to update property. Please try again.");
            setTimeout(() => setErrorMessage(""), 3000);
        } finally {
            setIsLoading(false);
        }
    };
    

    return (

        <div className="updateProperty">
            {isLoading && (
                <div className="loaderContainer">
                    <div className="loader"></div>
                    <p className="loadingText">Updating your property details...</p>
                </div>
            )}
            <div className="addProperty updateProp">
                                
                {/* Success Message */}
                <div className={`${successMessage ? "successMessageAdd" : "hiddes"} ${errorMessage ? "errorMessage" : "hidden"}`}>
                    {successMessage && successMessage} {errorMessage && errorMessage} 
                </div>

            
                <div className="formTitle">
                    <h1 className="addTitle">Update Property</h1>
                    <div className="underline"></div>                      
                </div>
                
                
                {formStep === 1 && (
                    <form className="addPropertyForm" onSubmit={handleFormSubmit}>

                        <FormInput 
                            label="Title" 
                            name="title" 
                            type="text" 
                            placeholder="Enter the title" 
                            required={false}
                            value={property.title} 
                            onChange={handleChange} 
                            className={errors.title ? "error" : ""}
                            errorMessage={errors.title}
                            astriskClass="hideMe"
                        />

                        <div className="inputs">
                            <label className="label">
                                Description <span className="asterisk">{errors.description}</span>
                            </label>
                            <textarea
                                className={`fullName propertyDesc ${errors.description ? "error" : ""}`}
                                type="text"
                                name="description"
                                placeholder="Enter property description"
                                autoCapitalize="off"
                                autoCorrect="off"
                                maxLength="2000"
                                value={property.description}
                                onChange={handleChange}
                            />
                        </div>


                        <FormInput 
                            label="Price" 
                            name="price" 
                            type="number" 
                            placeholder="Enter price" 
                            value={property.price} 
                            required={false}
                            onChange={handleChange} 
                            className={errors.price ? "error" : ""}
                            errorMessage={errors.price}
                            astriskClass="hideMe"
                        />

                        <FormInput 
                            label="Address" 
                            name="address" 
                            type="text" 
                            placeholder="XX4 6XX LONDON" 
                            required={false}
                            value={property.address} 
                            onChange={handleChange}
                            className={errors.address ? "error" : ""}
                            errorMessage={errors.address} 
                            astriskClass="hideMe"
                        />

                        <div className="rooms">
                            <FormInput 
                                label="Bedrooms" 
                                name="rooms" 
                                type="number" 
                                placeholder="Bedrooms" 
                                required={false}
                                value={property.rooms} 
                                onChange={handleChange} 
                                className={errors.rooms ? "error" : ""}
                                errorMessage={errors.rooms}
                                astriskClass="hideMe"
                            />

                            <FormInput 
                                label="Bathrooms" 
                                name="bathrooms" 
                                type="number" 
                                placeholder="Bathrooms" 
                                value={property.bathrooms} 
                                required={false}
                                onChange={handleChange}
                                className={errors.bathrooms ? "error" : ""}
                                errorMessage={errors.bathrooms} 
                                astriskClass="hideMe"
                            />

                            <FormInput 
                                label="Receptions" 
                                name="receptions" 
                                type="number" 
                                placeholder="Receptions" 
                                required={false}
                                value={property.receptions} 
                                onChange={handleChange} 
                                errorMessage={errors.receptions}
                                className={errors.receptions ? "error" : ""}
                                astriskClass="hideMe"
                            />
                        </div>

                        <div className="formButtons">
                           
                            <button type="button" className="cancelAuction" onClick={onClose}>Cancel</button>

                            <button type="button" className={`goNext ${!isValid ? 'disabled' : ''}`} onClick={nextStep} disabled={!isValid}>
                                Next →
                            </button>
                        </div>

                        
                    </form>
                )}

                {formStep === 2 && (
                    <form className="addPropertyForm" onSubmit={handleFormSubmit}>
                        <div className="inputs">
                            <label className="label">
                                Legal Terms <span className="asterisk"> {errors.legalTerms}</span>
                            </label>
                            <textarea
                                className={`fullName propertyDesc ${errors.legalTerms ? "error" : ""}`}
                                type="text"
                                name="legalTerms"
                                placeholder="Enter the legal terms and conditions related to this property sale, including any specific laws or agreements."
                                autoCapitalize="off"
                                autoCorrect="off"
                                maxLength="2000"
                                value={property.legalTerms}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="inputs">
                            <label className="label">
                                Disclaimer <span className="asterisk"> {errors.disclaimer}</span>
                            </label>
                            <textarea
                                className={`fullName propertyDesc ${errors.disclaimer ? "error" : ""}`}
                                type="text"
                                name="disclaimer"
                                placeholder="Enter any disclaimers or important information related to the property, such as potential risks or legal limitations."
                                autoCapitalize="off"
                                autoCorrect="off"
                                maxLength="2000"
                                value={property.disclaimer}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="inputs">
                            <label className="label">
                                Terms for Sale <span className="asterisk">{errors.termsForSale}</span>
                            </label>
                            <textarea
                                className={`fullName propertyDesc ${errors.termsForSale ? "error" : ""}`}
                                type="text"
                                name="termsForSale"
                                placeholder="Provide the specific terms and conditions for the sale of the property, such as payment terms, warranties, or seller obligations."
                                autoCapitalize="off"
                                autoCorrect="off"
                                maxLength="2000"
                                value={property.termsForSale}
                                onChange={handleChange}
                            />
                        </div>
                        
                  

                        <div className="formButtons">
                            <button type="button" className="goBack" onClick={prevStep}>
                                ← Back
                            </button>
                            <button type="button" className="cancelAuction" onClick={onClose}>Cancel</button>
                            <button type="submit" className="submitPropertyButton submitUpdateProperty">
                                Update
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
